import React from 'react';

const Save = () => (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/save" fill="#495E61">
                <path
                    d="M24,8.39529686 L24,12.0044643 C24,12.8328914 23.3284271,13.5044643 22.5,13.5044643 L13.5,13.5044643 C12.6715729,13.5044643 12,12.8328914 12,12.0044643 L12,7.5 L7.5,7.5 L7.5,28.5 L12,28.5 L12,19.5 C12,18.6715729 12.6715729,18 13.5,18 L22.5,18 C23.3284271,18 24,18.6715729 24,19.5 L24,28.5 L28.5,28.5 L28.5,13.0531164 L24,8.39529686 Z M7,6 L23.7715542,6 L30,12.4468836 L30,29 C30,29.5522847 29.5522847,30 29,30 L7,30 C6.44771525,30 6,29.5522847 6,29 L6,7 C6,6.44771525 6.44771525,6 7,6 Z M22.5,19.5 L13.5,19.5 L13.5,28.4874431 L22.5,28.4982052 L22.5,19.5 Z M13.5,7.5 L13.5,12.0044643 L22.5,12.0044643 L22.5,7.5 L13.5,7.5 Z"
                    id="Combined-Shape"
                ></path>
            </g>
        </g>
    </svg>
);

export default Save;
